<template>
    <div class="l content_right">
        <div class="sea_bar cl">
            <div class="r">
                <div class="l filter_item inpt cl">
                    <el-input class="l" placeholder="企业名称"  icon="search" :on-icon-click="reloadListData" v-model="filter.tenantName" @keyup.enter.native="reloadListData"></el-input>
                    <el-select class="l" v-model="filter.tenantapplytype" placeholder="开通用途" clearable @change="reloadListData">
                        <el-option
                                v-for="item in selectOptions.applytype"
                                :key="item.dictionaryid"
                                :label="item.dicvalue"
                                :value="item.dictionaryid">
                        </el-option>
                    </el-select>
                    <el-select class="l" v-model="filter.status" placeholder="企业状态" clearable @change="reloadListData">
                        <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="tools_bar">
            <el-button @click="newTenant">新建企业</el-button>
            <el-button :disabled="toolsDisabled.openAccount" @click="showOpenAccountSteps">开户</el-button>
            <el-button :disabled="toolsDisabled.defaultTools" @click="showAppModelSet">设置应用模块</el-button>
            <el-button :disabled="toolsDisabled.defaultTools" @click="showDevSet">设置开发人员</el-button>
            <el-button :disabled="toolsDisabled.defaultTools" @click="showLicenceSet">设置License数</el-button>
            <el-button :disabled="toolsDisabled.defaultTools" @click="showInitPasswordDia">设置初始密码</el-button>
            <el-button @click="handleImport">导入</el-button>
            <el-button @click="handleExport">导出</el-button>
            <el-button :disabled="toolsDisabled.defaultTools" @click="configDatabase">配置数据库</el-button>
            <el-button :disabled="toolsDisabled.defaultTools" @click="handleEnable">启用</el-button>
            <el-button :disabled="toolsDisabled.defaultTools" @click="handleDisable">停用</el-button>
            <el-button :disabled="toolsDisabled.defaultTools" @click="showClearMetadataDia">清理租户级元数据</el-button>
            <el-button :disabled="toolsDisabled.defaultTools" @click="showGenerateAccount">生成管理员账号</el-button>
        </div>
        <div class="table_container">
            <el-table :data="list" @selection-change="listSelect" border style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column min-width="200" fixed label="企业名称">
                    <template scope="scope">
                        <a class="tabLink" @click="showConfigDia(scope.row)">{{scope.row.tenantname}}</a>
                    </template>
                </el-table-column>
                <el-table-column width="150" prop="tenantcode" label="企业号"></el-table-column>
                <el-table-column width="130" prop="contact" label="企业联系人"></el-table-column>
                <el-table-column width="130" prop="mobile" label="联系人手机号"></el-table-column>
                <el-table-column width="100" prop="tenanttypename" label="租户类型"></el-table-column>
                <el-table-column width="100" prop="industryname" label="所属行业"></el-table-column>
                <el-table-column width="130" prop="productversionname" label="产品版本名称"></el-table-column>
                <el-table-column width="150" label="套餐">
                    <template scope="scope">
                        <span>{{scope.row.servicepackagename ? scope.row.servicepackagename : '未设置套餐'}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="100" prop="statusTxt" label="企业状态"></el-table-column>
                <el-table-column width="100" prop="openstatusTxt" label="开通状态"></el-table-column>
                <el-table-column width="100" prop="tenantapplytypeTxt" label="开通用途"></el-table-column>
                <el-table-column width="180" prop="createtime" label="开通日期"></el-table-column>
                <el-table-column width="140" prop="expiredtime" label="有效截止日期"></el-table-column>
            </el-table>
            <div class="paging">
                <el-pagination 
                    @current-change="handleCurrentPage" 
                    :current-page.sync="currentPage" 
                    :page-size="pageSize" 
                    layout="total, prev, pager, next" 
                    :total="totalSize">
                </el-pagination>
            </div>
        </div>
        <el-dialog v-model="dia.edit" :title="editDiaTitle">
            <edit 
                v-if="dia.edit" 
                @cancel="cancel('1')"
                @reload="reloadListData"
                :param="paramEdit"
                :optionsIndustry="selectOptions.industry" 
                :optionsPersonnelScale="selectOptions.personnelscale" 
                :optionsSourceType="selectOptions.sourcetype"
                :optionsApplyType="selectOptions.applytype"
                :implementlevel="implementlevel"
                >
            </edit>
        </el-dialog> 
        <el-dialog v-model="dia.settingPassword" title="设置账号密码方案">
            <setting-password v-if="dia.settingPassword" :param="paramSettingPassword" @cancel="cancel('2')"></setting-password>
        </el-dialog>
        <el-dialog v-model="dia.settingDeveloper" title="设置开发" class="dia-dev-set">
            <setting-developer v-if="dia.settingDeveloper" :param="paramSettingDeveloper" @cancel="cancel('4')"></setting-developer>
        </el-dialog>
        <el-dialog title="数据导入" v-model="dia.importFile">
            <import-file v-if="dia.importFile" @cancelImportDia="cancel('5')"></import-file>
        </el-dialog>
        <el-dialog v-model="dia.settingDatabase" title="配置数据库">
            <setting-database v-if="dia.settingDatabase" :param="paramSettingDatabase" @cancel="cancel('6')"></setting-database>
        </el-dialog>
        <el-dialog v-model="dia.settingLicense" title="设置License数">
            <setting-license v-if="dia.settingLicense" :param="paramSettingLicense" @cancel="cancel('7')"></setting-license>
        </el-dialog>
        <el-dialog v-model="dia.openAccount" title="开户">
            <open-account v-if="dia.openAccount" :param="paramOpenAccount" @cancel="cancel('8')" @reload="reloadListData"></open-account>
        </el-dialog>
        <el-dialog v-model="dia.clearMetadata" title="确认">
            <clear-metadata v-if="dia.clearMetadata" :param="paramClearMetadata" @cancel="cancel('9')"></clear-metadata>
        </el-dialog>
        <el-dialog v-model="dia.generateAccount" title="生成管理员账号">
            <generate-account v-if="dia.generateAccount" :param="paramGenerateAccount" @cancel="cancel('10')"></generate-account>
        </el-dialog>
    </div>
</template>
<script>
    import {errorMessage} from '../../util/index'
    import ImportFile from './dialog/Import'
    import SettingLicense from './dialog/SettingLicense'
    import SettingPassword from './dialog/SettingPassword'
    import SettingDatabase from './dialog/SettingDatabase'
    import OpenAccount from './dialog/OpenAccount'
    import SettingDeveloper from './dialog/SettingDeveloper'
    import ClearMetadata from './dialog/ConfirmClearMetadata'
    import GenerateAccount from './dialog/GenerateAccount'
    import Edit from './dialog/Edit'
    export default {
        props: ['implementlevel'],
        data() {
            return {
                list: [],
                currentPage: 1,
                pageSize: 15,
                totalSize: 30,
                editDiaTitle: '',
                selection: [],
                paramEdit: null,
                paramSettingLicense: null,
                paramSettingLicense: null,
                paramSettingDatabase: null,
                paramOpenAccount: null,
                paramSettingDeveloper: null,
                paramClearMetadata: null,
                paramGenerateAccount: null,
                selectOptions: {
                    personnelScale: [],  // 用户规模
                    sourcetype: [],  //资源等级
                    industry: [],  //所属行业
                    applytype: []  // 开通用途
                },
                filter: {
                    tenantName: '',  // 企业名称
                    status: '',
                    tenantapplytype: ''
                },
                toolsDisabled: {
                    openAccount: true,
                    setDev: true,
                    configAccount: true,
                    defaultTools: true
                },
                dia: {
                    edit: false,
                    settingLicense: false,
                    settingPassword: false,
                    settingDatabase: false,
                    settingDeveloper: false,
                    openAccount: false,
                    importFile: false,
                    clearMetadata: false,
                    generateAccount: false
                },
                statusList: [
                    {label: '启用', value: 1},
                    {label: '停用', value: 2},
                    {label: '下线', value: 3}
                ]
            }
        },
        components: {
            ImportFile,
            SettingLicense,
            SettingPassword,
            SettingDatabase,
            OpenAccount,
            SettingDeveloper,
            Edit,
            ClearMetadata,
            GenerateAccount
        },
        created: function(){
             this.init()
        },
        methods: {
            init(){
                // 初始化下拉框选项数据
                this.initOptionData()
                // 初始化列表数据
                this.loadList().then(res => {
                    this.list = this.parseListData(res.data.resp_data.data)
                    this.totalSize = res.data.resp_data.resultCount
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            // 新建企业
            newTenant() {
                this.paramEdit = {
                    edit: false,
                    editTab: 'first',
                    data: {}
                }
                this.editDiaTitle = '新建企业'
                this.dia.edit = true
            },
            // 编辑弹窗
            showConfigDia(data, editTab = 'first') {
                this.paramEdit = {
                    edit: true,
                    editTab,
                    data
                }
                this.editDiaTitle = '编辑企业'
                this.dia.edit = true
            },
            // 列表选择-选择租户
            listSelect(data) {
                this.selection = data
                if (this.selection.length > 1 || this.selection.length == 0) {
                    for (let i in this.toolsDisabled) {
                        this.toolsDisabled[i] = true
                    }
                } else {
                    let tenant = this.selection[0]
                    this.toolsDisabled.openAccount = tenant.openstatus === 100
                    this.toolsDisabled.setDev = tenant.implementlevel == 0
                    this.toolsDisabled.configAccount = !(tenant.openstatus == 4 || tenant.openstatus == 5 || tenant.openstatus == 6)
                    this.toolsDisabled.defaultTools = false
                }
            },
            // 租户列表
            loadList(data = {}){
                return this.$http.post(`/platserv/tenant/list`,{
                    tenantname: this.filter.tenantName,
                    page: this.currentPage,
                    rows: this.pageSize,
                    tenantapplytype: this.filter.tenantapplytype,
                    status: this.filter.status,
                    implementlevels: this.implementlevel == '0' ? [0] : [1, 2, 3, 4]
                })
            },
            // 分页页码切换
            handleCurrentPage(data) {
                this.currentPage = data
                this.reloadListData()
            },
            // 导入
            handleImport() {
                this.dia.importFile = true
            },
            // 导出
            handleExport(obj, url){
                let _this = this
                if (this.selection.length === 0) {
                    this.$message.warning('请选择租户！')
                    return
                } else if (this.selection.length > 1) {
                    this.$message.warning('只能导出单个租户！')
                    return
                }
                let params = {
                    tenantcode: this.selection[0].tenantcode
                }
                this.$http.post(`/platserv/tenant/export`, {tenantcode: this.selection[0].tenantcode},{
                    'responseType': 'blob'
                }).then(res => {
                    if(res.body.size == 0){
                        _this.$message.info('没有可导出文件')
                        return
                    }
                    return res.blob()
                }).then(blob => {
                    if(blob == undefined){
                        _this.$message.info('没有可导出文件')
                        return
                    }
                    _this.downFile(blob, _this)
                }).catch(error => {
                    let msg = (error.body && error.body.error_code) || error.statusText || error
                    this.$message.error(msg)
                })
            },
            downFile(blob, self) {
                let a = document.createElement('a')
                //a.download = self.filename
                a.href = window.URL.createObjectURL(blob)
                document.body.appendChild(a)
                let evt = document.createEvent('MouseEvents')
                evt.initEvent('click', false, false)

                a.dispatchEvent(evt)
                document.body.removeChild(a)
                // self.$message.success('处理成功')
            },
            // 配置数据库弹窗
            configDatabase() {
                let data = this.selection[0]
                this.paramSettingDatabase = {
                    tenantCode: data.tenantcode,
                    productCode: data.productcode
                }
                this.dia.settingDatabase = true
            },
            // 将列表信息装换格式
            parseListData(data) {
                let _this = this
                let ret = []
                data.forEach(function(item){
                    item.statusTxt = _this.getText('status',item.status)
                    item.openstatusTxt = _this.getText('openstatus',item.openstatus)
                    item.tenantapplytypeTxt = _this.getText('tenantapplytype',item.tenantapplytype)
                    item.expiredtime = item.expiredtime ? item.expiredtime.split(' ')[0] : ''
                })
                return data
            },
            // 设置应用模块
            showAppModelSet() {
                this.showConfigDia(this.selection[0], 'second')
            },
            // 设置开发人员
            showDevSet() {
                this.paramSettingDeveloper = {
                    tenantCode: this.selection[0].tenantcode
                }
                this.dia.settingDeveloper = true
            },
            // 设置初始密码
            showInitPasswordDia() {
                this.paramSettingPassword = {
                    tenantCode: this.selection[0].tenantcode
                }
                this.dia.settingPassword = true
            },
            // 设置License数
            showLicenceSet() {
                let data = this.selection[0]
                this.paramSettingLicense = {
                    productPackageCode: data.productpackagecode,
                    tenantCode: data.tenantcode
                }
                this.dia.settingLicense = true
            },
            // 开户
            showOpenAccountSteps() {
                let data = this.selection[0]
                this.paramOpenAccount = {
                    tenantCode: data.tenantcode,
                    productCode: data.productcode,
                    productVersionCode: data.productversioncode
                }
                this.dia.openAccount = true
            },
            // 清除元数据
            showClearMetadataDia() {
                this.paramClearMetadata = {
                    tenantCode: this.selection[0].tenantcode
                }
                this.dia.clearMetadata = true
            },
            // 生成管理员账号
            showGenerateAccount() {
                let row = this.selection[0]
                if(row.openstatus != '100') {
                    this.$message.warning('租户尚未开通，不能生成管理员账号！')
                    return
                }
                
                this.paramGenerateAccount = {
                    tenantCode: row.tenantcode,
                    productCode: row.tenantcode,
                    productVersionCode: row.productversioncode
                }
                this.dia.generateAccount = true
            },
            // 关闭弹窗
            cancel(key) {
                switch(key){
                    case '1':
                        this.dia.edit = false
                        break
                    case '2':  //设置初始密码
                        this.dia.settingPassword = false
                        break
                    case '4':  //设置开发人员
                        this.dia.settingDeveloper = false
                        break
                    case '5':  //导入
                        this.dia.importFile = false
                        break
                    case '6':  //配置数据库
                        this.dia.settingDatabase = false
                        break
                    case '7':  //设置license
                        this.dia.settingLicense = false
                        break
                    case '8':  //开户
                        this.dia.openAccount = false
                        break
                    case '9':  //清理元数据
                        this.dia.clearMetadata = false
                        break
                    case '10':  //生成管理员账号
                        this.dia.generateAccount = false
                        break
                }
            },
            // 初始化下拉框数据
            initOptionData() {
                let _this = this
                let optionsType = ['personnelscale', 'sourcetype', 'applytype']
                optionsType.forEach(function(item){
                    _this.getDictionary(item).then(function(res){
                        _this.selectOptions[item] = res.data.resp_data
                    }).catch(error => {
                        errorMessage(error, _this)
                    })
                })
                this.getIndustry().then(function(res){
                    _this.selectOptions.industry = res.data.resp_data
                }).catch(error => {
                    errorMessage(error, _this)
                })
            },
            // 租户列表重新加载
            reloadListData() {
                this.loadList().then(res => {
                    this.list = this.parseListData(res.data.resp_data.data)
                    this.totalSize = res.data.resp_data.resultCount
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            getDictionary(type){
                return this.$http.post(`/platserv/dictionary/getDictionaryByKey`,{dickey: type})
            },
            //获取所属行业
            getIndustry(){
                return this.$http.post(`/platserv/industry/getAllIndustry`,{})
            },
            // 列表数据根据代码获取中文名称
            getText(type,code) {
                let _this = this
                let ret = ''
                switch(type){
                    case 'status':
                        if(code == 1){
                            ret = '启用'
                        }else if (code == 2){
                            ret = '停用'
                        }else if (code == 3){
                            ret = '下线'
                        }
                        break
                    case 'openstatus':
                        if(code == 1){
                            ret = '租户登记（待申请资源）'
                        }else if (code == 2) {
                            ret = '资源申请（待数据初始化）'
                        }else if (code == 3) {
                            ret = '数据初始化过程中'
                        }else if (code == 4) {
                            ret = '数据初始化（待初始帐号）'
                        }else if (code == 5) {
                            ret = '帐号已建（待租户建帐号）'
                        }else if (code == 6) {
                            ret = '帐号已建（待初始化调度）'
                        }else if (code == 100) {
                            ret = '开通完成'
                        }
                        break
                    case 'tenantapplytype':
                        if (code == 1) {
                            ret = '试用'
                        } else if (code == 2) {
                            ret = '商用'
                        }
                        break
                }
                return ret
            },
            handleEnable() {
                let _this = this
                _this.$confirm('请确认需要启用的租户', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.$http.post(`/platserv/tenant/enable`,{
                        tenantcode: _this.selection.map(item => item.tenantcode).join('')
                    }).then(res => {
                        if (res.data.resp_data === 'ok') {
                            _this.$message.success('启用成功！')
                            _this.reloadListData()
                        } else {
                            _this.$message.error('启用失败！')
                        }
                    }).catch(error => {
                        errorMessage(error, _this)
                    })
                }).catch(() => {})
            },
            handleDisable() {
                let _this = this
                _this.$confirm('请确认需要停用的租户', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.$http.post(`/platserv/tenant/disable`,{
                        tenantcode: _this.selection.map(item => item.tenantcode).join('')
                    }).then(res => {
                        if (res.data.resp_data === 'ok') {
                            _this.$message.success('停用成功！')
                            _this.reloadListData()
                        } else {
                            _this.$message.error('停用失败！')
                        }
                    }).catch(error => {
                        errorMessage(error, _this)
                    })
                }).catch(() => {})
            }
        }
    }
</script>


// WEBPACK FOOTER //
// TenantsManager.vue?58b473ec